<ion-content class="bg-color ion-content">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card>
        <mat-card-title class="mc-title">
          <span class="table-header">Live Streaming Logs : {{name}}</span>
          <span class="table-header content-stream" style="margin-left: 30px;">
            <mat-form-field class="data-column" appearance="outline">
            <mat-label>Log level</mat-label>
            <mat-select (selectionChange)="OnChangeStreamlogType($event)" [(ngModel)]="log_level" id="ib_update_source_type">
              <mat-option *ngFor="let obj of streamlogtypes" [value]="obj" selected>{{obj}}
              </mat-option>
            </mat-select>
            </mat-form-field>
            <!-- <button mat-stroked-button class="next" > -->
              <mat-icon class="icon refresh-icon" (click)="refreshPage()">
                refresh
              </mat-icon>
              <mat-icon class="icon refresh-icon" matTooltip="Streams every 15 min, Refresh for the next stream window" matTooltipPosition="above">
                info
              </mat-icon>
            <!-- </button> -->
          </span>
        </mat-card-title>
        <mat-card-content class="mc-content">
          <!-- <cdk-virtual-scroll-viewport itemSize="auto" class="example-viewport"  id="streamData" >
            <div *cdkVirtualFor="let item of streamLogs$; trackBy: trackByFn" class="example-item">
              <div style="width: 50px;">{{item.id}}</div>
                <div class="streaming-body" [innerHTML]="item.body"></div>
            </div> -->
            <div class="log-viewer">
              <!-- (mouseup)="stopDragging($event, false)"
              (mouseleave)="stopDragging($event, false)"  (mousemove)="moveEvent($event)"  (mouseleave)="stopDragging($event, false)"-->
              <!-- <div class="log-stream" id="logs" (mouseup)="startDragging($event, false)">
                <div *ngFor="let log of streamLogs$ | async;" class="example-item">
                  <div style="width: 50px;">{{log.id}}</div>              
                  <div class="streaming-body" [innerHTML]="log.body"></div>
                </div>
              </div> -->
              <div class="log-stream" id="logs" #logContainer>

              </div>
            </div>
        <!-- </cdk-virtual-scroll-viewport> -->
        </mat-card-content>
      </mat-card>
    </div>
   </div>
</ion-content>